<template>
  <v-container v-if="userService.hasRight('todo_fetchAndEdit')" fluid>
    <v-row>
      <v-col cols="12" class="mt-5">
        <v-select
          v-if="userService.hasRight('todo_changeStudio')"
          :disabled="onlyUserTodos"
          hide-details
          @change="reloadTodos"
          :items="studios"
          label="Studio auswählen"
          v-model="selectedStudio"
          item-text="name"
          item-value="_id"></v-select>
      </v-col>

      <v-col cols="12" class="d-flex justify-center my-0 py-0">
        <v-switch hide-details color="primary" v-model="onlyUserTodos" @change="reloadTodos" label="meine ToDos"> </v-switch>
      </v-col>
      <v-col cols="12">
        <v-card-text align="center"> Falls du deine ToDos (Centerübergreifend) sehen möchtest, aktiviere den Schalter. <br /> </v-card-text>
      </v-col>
      <v-col cols="12" class="mb-5" align="center">
        <v-btn color="secondary" @click="openCreateDialog">ToDo hinzufügen<v-icon class="ml-1">mdi-plus</v-icon></v-btn>
      </v-col>
    </v-row>

    <div class="d-flex justify-center mb-4">
      <v-btn-toggle v-model="activeTab" dark dense background-color="primary" group>
        <v-btn value="techniker"> Techniker </v-btn>
        <v-btn value="marketing"> Marketing </v-btn>
        <v-btn v-show="userService.hasRight('coo_toDoListItems')" value="coo"> COO </v-btn>
        <v-btn v-show="userService.hasRight('cl_toDoListItems')" value="cl"> CL </v-btn>
        <v-btn value="resolved"> Erledigt </v-btn>
      </v-btn-toggle>
    </div>

    <v-window v-model="activeTab">
      <v-window-item key="techniker" value="techniker">
        <v-row align="center" class="mb-2">
          <v-col cols="12" class="d-flex justify-end">
            <v-slide-x-transition>
              <div v-if="technikerSearchActive">
                <v-text-field
                  hide-details
                  v-model="technikerSearchQuery"
                  label="Suche in Techniker-Todos"
                  clearable
                  @click:clear="technikerSearchQuery = ''"
                  append-icon="mdi-close"
                  @click:append="technikerSearchActive = false"></v-text-field>
              </div>
            </v-slide-x-transition>
            <v-btn icon v-if="!technikerSearchActive" @click="technikerSearchActive = true">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-data-table
          :items-per-page="-1"
          :headers="headers"
          :items="filteredTodosByCategory('techniker')"
          class="elevation-1"
          :sort-by="['priorityValue', 'createdAt']"
          :sort-desc="[true, true]"
          clickable
          @click:row="openDetailDialog">
          <template v-slot:item.priority="{ item }">
            <v-chip :color="getPriorityColor(item.priority)" dark>
              {{ mapPriorityName(item.priority) }}
            </v-chip>
          </template>
          <template v-slot:item.createdBy="{ item }">
            {{ item.createdBy.vorname[0].toUpperCase() }}{{ item.createdBy.nachname[0].toUpperCase() }}
          </template>
          <template v-slot:item.assignedUsers="{ item }">
            <span v-if="item.assignedUsers?.length">
              <span v-for="(u, i) in item.assignedUsers" :key="item._id + '-' + u._id">
                {{ u.user.vorname[0].toUpperCase() }}{{ u.user.nachname[0].toUpperCase() }}
                {{ i + 1 !== item.assignedUsers.length ? ", " : "" }}
              </span>
            </span>
            <span v-else>-</span>
          </template>
          <template v-slot:item.studio="{ item }">
            {{ item.studio?.name || "Kein Studio" }}
          </template>
          <template v-slot:item.plannedDate="{ item }">
            {{ getPlannedDateOfEntry(item) }}
          </template>
          <template v-slot:item.createdAt="{ item }">
            <span>{{ $moment(item.createdAt).format("DD.MM.YY HH:mm") }}</span>
          </template>
        </v-data-table>
      </v-window-item>

      <v-window-item key="marketing" value="marketing">
        <v-row align="center" class="mb-2">
          <v-col cols="12" class="d-flex justify-end">
            <v-slide-x-transition>
              <div v-if="marketingSearchActive">
                <v-text-field
                  hide-details
                  v-model="marketingSearchQuery"
                  label="Suche in Marketing-Todos"
                  clearable
                  @click:clear="marketingSearchQuery = ''"
                  append-icon="mdi-close"
                  @click:append="marketingSearchActive = false"></v-text-field>
              </div>
            </v-slide-x-transition>
            <v-btn icon v-if="!marketingSearchActive" @click="marketingSearchActive = true">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-data-table
          :items-per-page="-1"
          :headers="headersMarketing"
          :items="filteredTodosByCategory('marketing')"
          class="elevation-1"
          :sort-by="['createdAt']"
          :sort-desc="[true]"
          clickable
          @click:row="openDetailDialog">
          <template v-slot:item.priority="{ item }">
            <v-chip :color="getPriorityColor(item.priority)" dark>
              {{ mapPriorityName(item.priority) }}
            </v-chip>
          </template>
          <template v-slot:item.createdBy="{ item }">
            {{ item.createdBy.vorname[0].toUpperCase() }}{{ item.createdBy.nachname[0].toUpperCase() }}
          </template>
          <template v-slot:item.assignedUsers="{ item }">
            <span v-if="item.assignedUsers?.length">
              <span v-for="(u, i) in item.assignedUsers" :key="item._id + '-' + u._id">
                {{ u.user.vorname[0].toUpperCase() }}{{ u.user.nachname[0].toUpperCase() }}
                {{ i + 1 !== item.assignedUsers.length ? ", " : "" }}
              </span>
            </span>
            <span v-else>-</span>
          </template>
          <template v-slot:item.studio="{ item }">
            {{ item.studio?.name || "Kein Studio" }}
          </template>
          <template v-slot:item.plannedDate="{ item }">
            {{ getPlannedDateOfEntry(item) }}
          </template>
          <template v-slot:item.inProgress="{ item }">
            <v-icon :color="item.inProgress ? 'orange' : 'grey'"> {{ item.inProgress ? "mdi-progress-pencil" : "mdi-calendar-question" }}</v-icon>
          </template>
          <template v-slot:item.createdAt="{ item }">
            <span>{{ $moment(item.createdAt).format("DD.MM.YY HH:mm") }}</span>
          </template>
        </v-data-table>
      </v-window-item>
      <v-window-item v-if="userService.hasRight('coo_toDoListItems')" key="coo" value="coo">
        <v-row align="center" class="mb-2">
          <v-col cols="12" class="d-flex justify-end">
            <v-slide-x-transition>
              <div v-if="cooSearchActive">
                <v-text-field
                  hide-details
                  v-model="cooSearchQuery"
                  label="Suche in COO-Todos"
                  clearable
                  @click:clear="cooSearchQuery = ''"
                  append-icon="mdi-close"
                  @click:append="cooSearchActive = false"></v-text-field>
              </div>
            </v-slide-x-transition>
            <v-btn icon v-if="!cooSearchActive" @click="cooSearchActive = true">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          :items-per-page="-1"
          :headers="headers"
          :items="filteredTodosByCategory('coo')"
          class="elevation-1"
          :sort-by="['priorityValue', 'createdAt']"
          :sort-desc="[true, true]"
          clickable
          @click:row="openDetailDialog">
          <template v-slot:item.priority="{ item }">
            <v-chip :color="getPriorityColor(item.priority)" dark>
              {{ mapPriorityName(item.priority) }}
            </v-chip>
          </template>
          <template v-slot:item.createdBy="{ item }">
            {{ item.createdBy.vorname[0].toUpperCase() }}{{ item.createdBy.nachname[0].toUpperCase() }}
          </template>
          <template v-slot:item.assignedUsers="{ item }">
            <span v-if="item.assignedUsers?.length">
              <span v-for="(u, i) in item.assignedUsers" :key="item._id + '-' + u._id">
                {{ u.user.vorname[0].toUpperCase() }}{{ u.user.nachname[0].toUpperCase() }}
                {{ i + 1 !== item.assignedUsers.length ? ", " : "" }}
              </span>
            </span>
            <span v-else>-</span>
          </template>
          <template v-slot:item.studio="{ item }">
            {{ item.studio?.name || "Kein Studio" }}
          </template>
          <template v-slot:item.plannedDate="{ item }">
            {{ getPlannedDateOfEntry(item) }}
          </template>
          <template v-slot:item.createdAt="{ item }">
            <span>{{ $moment(item.createdAt).format("DD.MM.YY HH:mm") }}</span>
          </template>
        </v-data-table>
      </v-window-item>

      <v-window-item v-if="userService.hasRight('cl_toDoListItems')" key="cl" value="cl">
        <v-row align="center" class="mb-2">
          <v-col cols="12" class="d-flex justify-end">
            <v-slide-x-transition>
              <div v-if="clSearchActive">
                <v-text-field
                  hide-details
                  v-model="clSearchQuery"
                  label="Suche in CL-Todos"
                  clearable
                  @click:clear="clSearchQuery = ''"
                  append-icon="mdi-close"
                  @click:append="clSearchActive = false"></v-text-field>
              </div>
            </v-slide-x-transition>
            <v-btn icon v-if="!clSearchActive" @click="clSearchActive = true">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          :items-per-page="-1"
          :headers="headers"
          :items="filteredTodosByCategory('cl')"
          class="elevation-1"
          :sort-by="['priorityValue', 'createdAt']"
          :sort-desc="[true, true]"
          clickable
          @click:row="openDetailDialog">
          <template v-slot:item.priority="{ item }">
            <v-chip :color="getPriorityColor(item.priority)" dark>
              {{ mapPriorityName(item.priority) }}
            </v-chip>
          </template>
          <template v-slot:item.createdBy="{ item }">
            {{ item.createdBy.vorname[0].toUpperCase() }}{{ item.createdBy.nachname[0].toUpperCase() }}
          </template>
          <template v-slot:item.assignedUsers="{ item }">
            <span v-if="item.assignedUsers?.length">
              <span v-for="(u, i) in item.assignedUsers" :key="item._id + '-' + u._id">
                {{ u.user.vorname[0].toUpperCase() }}{{ u.user.nachname[0].toUpperCase() }}
                {{ i + 1 !== item.assignedUsers.length ? ", " : "" }}
              </span>
            </span>
            <span v-else>-</span>
          </template>
          <template v-slot:item.studio="{ item }">
            {{ item.studio?.name || "Kein Studio" }}
          </template>
          <template v-slot:item.plannedDate="{ item }">
            {{ getPlannedDateOfEntry(item) }}
          </template>
          <template v-slot:item.createdAt="{ item }">
            <span>{{ $moment(item.createdAt).format("DD.MM.YY HH:mm") }}</span>
          </template>
        </v-data-table>
      </v-window-item>
      <v-window-item key="resolved" value="resolved">
        <v-row align="center" class="mb-2">
          <v-col cols="12" class="d-flex justify-end">
            <v-slide-x-transition>
              <div v-if="resolvedSearchActive">
                <v-text-field
                  hide-details
                  v-model="resolvedSearchQuery"
                  label="Suche in erledigten Todos"
                  clearable
                  @click:clear="resolvedSearchQuery = ''"
                  append-icon="mdi-close"
                  @click:append="resolvedSearchActive = false"></v-text-field>
              </div>
            </v-slide-x-transition>
            <v-btn class="mt-4" icon v-if="!resolvedSearchActive" @click="resolvedSearchActive = true">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="groupedResolvedTodosFiltered.length === 0">
          <v-col cols="12" class="mt-5">
            <v-alert type="info">Keine erledigten ToDo's gefunden</v-alert>
          </v-col>
        </v-row>
        <v-expansion-panels v-else accordion>
          <v-expansion-panel v-for="yearGroup in groupedResolvedTodosFiltered" :key="yearGroup.year">
            <v-expansion-panel-header>
              {{ yearGroup.year }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-expansion-panels accordion>
                <v-expansion-panel v-for="monthGroup in yearGroup.months" :key="monthGroup.monthName">
                  <v-expansion-panel-header> {{ monthGroup.monthName }} ({{ monthGroup.totalCount }}) </v-expansion-panel-header>
                  <v-expansion-panel-content class="pa-0">
                    <v-expansion-panels accordion>
                      <v-expansion-panel v-if="monthGroup.techniker.length > 0">
                        <v-expansion-panel-header>Techniker ({{ monthGroup.techniker.length }})</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-list dense>
                            <v-list-item v-for="todo in monthGroup.techniker" :key="todo._id" @click="openDetailDialog(todo)" style="cursor: pointer">
                              <v-list-item-content>
                                <v-list-item-title>{{ todo.title }}</v-list-item-title>
                                <v-list-item-subtitle>{{ formatDate(todo.createdAt) }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel v-if="monthGroup.marketing.length > 0">
                        <v-expansion-panel-header>Marketing ({{ monthGroup.marketing.length }})</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-list dense>
                            <v-list-item v-for="todo in monthGroup.marketing" :key="todo._id" @click="openDetailDialog(todo)" style="cursor: pointer">
                              <v-list-item-content>
                                <v-list-item-title>{{ todo.title }}</v-list-item-title>
                                <v-list-item-subtitle>{{ formatDate(todo.createdAt) }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel v-if="monthGroup.coo.length > 0 && userService.hasRight('coo_toDoListItems')">
                        <v-expansion-panel-header>COO ({{ monthGroup.coo.length }})</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-list dense>
                            <v-list-item v-for="todo in monthGroup.coo" :key="todo._id" @click="openDetailDialog(todo)" style="cursor: pointer">
                              <v-list-item-content>
                                <v-list-item-title>{{ todo.title }}</v-list-item-title>
                                <v-list-item-subtitle>{{ formatDate(todo.createdAt) }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel v-if="monthGroup.cl.length > 0 && userService.hasRight('cl_toDoListItems')">
                        <v-expansion-panel-header>CL ({{ monthGroup.cl.length }})</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-list dense>
                            <v-list-item v-for="todo in monthGroup.cl" :key="todo._id" @click="openDetailDialog(todo)" style="cursor: pointer">
                              <v-list-item-content>
                                <v-list-item-title>{{ todo.title }}</v-list-item-title>
                                <v-list-item-subtitle>{{ formatDate(todo.createdAt) }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-window-item>
    </v-window>

    <v-dialog fullscreen v-model="detailDialog">
      <v-card class="mx-auto" dark>
        <div style="max-width: 500px" class="d-flex flex-row align-center justify-space-between mx-auto px-5 pt-5">
          <div>
            <v-btn icon class="white" color="black" @click="closeDetailDialog"><v-icon>mdi-chevron-left</v-icon></v-btn>
            <v-chip color="white" class="mx-2 black--text">{{ formatDate(currentTodo?.createdAt) }}</v-chip>
            <v-chip small class="mx-2" :color="getPriorityColor(currentTodo?.priority)">{{ mapPriorityName(currentTodo?.priority) }}</v-chip>
          </div>
          <div>
            <v-btn icon class="orange" color="white" @click="toggleEditMode"><v-icon>mdi-pencil</v-icon></v-btn>
            <v-btn
              v-if="currentTodo?.category !== 'coo' && currentTodo?.category !== 'cl'"
              class="red ml-1"
              color="white"
              icon
              @click="deleteCurrentTodo">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </div>
        </div>

        <div style="max-width: 500px" class="mx-auto">
          <v-card-title>
            <div class="d-flex flex-column w-100">
              <v-card-subtitle class="px-0">
                Erstellt von: {{ currentTodo?.createdBy?.vorname }} {{ currentTodo?.createdBy?.nachname }} |
                {{ currentTodo?.studio?.name }}</v-card-subtitle
              >
              <div v-if="!editMode" class="w-100">
                <v-chip small :color="currentTodo?.resolved ? 'green' : 'orange'">{{ currentTodo?.resolved ? "Erledigt" : "Offen" }}</v-chip>
              </div>
              <div v-if="!editMode">
                <span class="headline">{{ currentTodo?.title }}</span>
              </div>
              <div v-else>
                <v-text-field width="100%" v-model="editedTodo.title" label="Titel" :rules="[(v) => !!v || 'Pflichtfeld']"></v-text-field>
              </div>
            </div>
          </v-card-title>
          <v-card-text>
            <div v-if="editMode">
              <v-textarea v-model="editedTodo.description" label="Beschreibung" auto-grow dense></v-textarea>
              <v-select
                v-if="userService.hasRight('todo_changeStudio')"
                :items="studios"
                label="Studio auswählen"
                v-model="editedTodo.studio"
                item-text="name"
                item-value="_id"></v-select>
              <v-select
                class="my-5"
                v-model="editedTodo.category"
                :items="availableCategories"
                label="Kategorie"
                hide-details
                :disabled="
                  (editedTodo.category === 'coo' && !userService.hasRight('coo_toDoListItems')) ||
                  (editedTodo.category === 'cl' && !userService.hasRight('cl_toDoListItems'))
                "></v-select>
              <v-select
                v-if="editedTodo.category === 'marketing'"
                v-model="editedTodo.subcategory"
                :items="[
                  { text: 'Umbau', value: 'Umbau' },
                  { text: 'Events', value: 'Events' },
                  { text: 'News', value: 'News' },
                  { text: 'Sonstiges', value: 'Sonstiges' },
                ]"
                label="Unterkategorie"
                hide-details></v-select>
              <v-select
                v-if="editedTodo.category === 'coo' && userService.hasRight('coo_toDoListItems')"
                v-model="editedTodo.subcategory"
                :items="sortedCooSubcategories"
                label="Unterkategorie"
                hide-details></v-select>
              <v-select
                v-if="editedTodo.category === 'cl' && userService.hasRight('cl_toDoListItems')"
                v-model="editedTodo.subcategory"
                :items="sortedClSubcategories"
                label="Unterkategorie"
                hide-details></v-select>
              <v-select
                v-if="editedTodo.category !== 'marketing' || userService.hasRight('todo_fetchAllMarketing')"
                v-model="editedTodo.priority"
                :items="priorityItems"
                label="Priorität"
                :rules="[(v) => !!v || 'Pflichtfeld']">
                <template v-slot:selection="{ item }">
                  <v-chip :color="getPriorityColor(item)" dark>{{ mapPriorityName(item) }}</v-chip>
                </template>
                <template v-slot:item="{ item }">
                  <v-chip :color="getPriorityColor(item)" dark>{{ mapPriorityName(item) }}</v-chip>
                </template>
              </v-select>
              <v-card-actions class="justify-center">
                <v-btn text color="white" @click="toggleEditMode">Abbrechen</v-btn>
                <v-btn text color="primary" @click="saveEdit">Speichern</v-btn>
              </v-card-actions>
            </div>
            <div v-else>
              <div>
                {{ currentTodo?.description }}
                <v-btn @click="copyTextToClipboard(currentTodo?.description)" icon><v-icon>mdi-content-copy</v-icon></v-btn>
              </div>

              <v-divider class="my-3"></v-divider>
              <v-file-input
                ref="fileInput"
                v-model="selectedFile"
                style="display: none"
                accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                @change="onFileSelected"></v-file-input>

              <v-dialog v-model="videoLinkDialog" max-width="500px">
                <v-card dark>
                  <v-card-title>Video-Link hinzufügen</v-card-title>
                  <v-card-text>
                    <v-text-field
                      v-model="newVideoLink"
                      label="Link hier einfügen"
                      placeholder="https://www.youtube.com/watch?v=..."
                      outlined
                      dense
                      clearable></v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="videoLinkDialog = false">Abbrechen</v-btn>
                    <v-btn color="primary" @click="addVideoLink">Hinzufügen</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-row dense class="my-4">
                <v-col>
                  <v-btn block outlined @click="triggerFileUpload">
                    <v-icon left>mdi-paperclip</v-icon>
                    Datei anhängen
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn block outlined @click="videoLinkDialog = true">
                    <v-icon left>mdi-video-plus-outline</v-icon>
                    Video-Link
                  </v-btn>
                </v-col>
              </v-row>

              <v-col cols="12">
                <v-row :key="currentTodoAttachments.length" class="d-flex justify-center">
                  <v-col v-for="(attachment, index) in currentTodoAttachments" :key="attachment._id" cols="12" sm="6" md="4">
                    <v-card>
                      <v-img
                        v-if="attachment.type === 'image'"
                        :src="attachment.url"
                        aspect-ratio="1.2"
                        class="pointer"
                        @click="openAttachementDialog(index)"></v-img>

                      <v-card-text v-else class="text-center pa-4">
                        <v-icon x-large class="mb-2">{{ getAttachmentIcon(attachment.type) }}</v-icon>
                        <p class="mb-2 text-truncate" :title="attachment.originalName">{{ attachment.originalName }}</p>
                        <v-btn
                          v-if="attachment.type === 'pdf' || attachment.type === 'document'"
                          small
                          color="primary"
                          @click="openAttachment(attachment)">
                          Öffnen
                        </v-btn>

                        <v-btn
                          v-if="attachment.type === 'video'"
                          small
                          color="primary"
                          :href="attachment.url"
                          target="_blank"
                          rel="noopener noreferrer">
                          Ansehen
                        </v-btn>
                      </v-card-text>

                      <v-btn absolute top right icon small class="red" @click="deleteSelectedAttachment(attachment._id)">
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>

              <v-dialog persistent v-model="attachementDialog" max-width="800">
                <v-card dark>
                  <v-img
                    contain
                    :src="currentTodoAttachments[selectedAttachementIndex] ? currentTodoAttachments[selectedAttachementIndex].url : ''"
                    aspect-ratio="1.75"></v-img>
                  <v-card-actions>
                    <v-btn class="mx-auto" text color="primary" @click="attachementDialog = false">Schliessen</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-row v-if="currentTodo">
                <v-col cols="12">
                  <v-row :key="currentTodoImages.length" class="d-flex justify-center">
                    <v-col v-for="(image, index) in currentTodoImages" :key="index" cols="12" sm="6" md="4" lg="3">
                      <v-card>
                        <v-img :src="image" aspect-ratio="1" class="pointer" @click="openImageDialog(index)"></v-img>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
                <v-dialog persistent v-model="imageDialog" max-width="800">
                  <v-card dark>
                    <v-row no-gutters>
                      <v-col cols="12" align="end">
                        <v-btn @click="deleteSelectedImage" class="red ma-2"><v-icon>mdi-delete</v-icon></v-btn>
                      </v-col>
                    </v-row>

                    <v-img :src="currentTodoImages[selectedImageIndex]" aspect-ratio="1.75"></v-img>
                    <v-card-actions>
                      <v-btn class="mx-auto" text color="primary" @click="imageDialog = false">Schliessen</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
              <v-switch
                v-if="currentTodo?.category === 'marketing' && userService.hasRight('todo_fetchAllMarketing')"
                class="my-5"
                hide-details
                v-model="currentTodo.inProgress"
                @change="updateInProgressStatus"
                label="In Bearbeitung">
              </v-switch>
              <v-switch
                v-if="currentTodo?.category !== 'coo' && currentTodo?.category !== 'cl'"
                class="my-5"
                hide-details
                v-model="isResolved"
                label="Erledigt"></v-switch>
              <div class="mt-2" v-if="currentTodo">
                <v-row v-if="currentTodo?.category == 'cl'" class="my-5">
                  <v-col cols="6">
                    <v-menu ref="dateMenu" v-model="dateMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="currentTodo.plannedDate"
                          label="Geplant - Datum"
                          prepend-icon="mdi-calendar"
                          readonly
                          hide-details
                          outlined
                          v-bind="attrs"
                          v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="currentTodo.plannedDate" @input="dateMenu = false"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="6">
                    <v-menu ref="timeMenu" v-model="timeMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="currentTodo.plannedTime"
                          label="Geplant - Uhrzeit"
                          prepend-icon="mdi-clock"
                          readonly
                          outlined
                          hide-details
                          v-bind="attrs"
                          v-on="on"></v-text-field>
                      </template>
                      <v-time-picker v-model="currentTodo.plannedTime" @input="timeMenu = false"></v-time-picker>
                    </v-menu>
                  </v-col>
                </v-row>

                <v-textarea class="mt-2" hide-details v-model="newComment" label="Kommentar" auto-grow outlined></v-textarea>

                <v-switch
                  v-if="currentTodo?.category === 'marketing' && userService.hasRight('todo_fetchAllMarketing')"
                  hide-details
                  v-model="isMarketingOnlyComment"
                  label="Kommentar nur für Marketing sichtbar">
                </v-switch>

                <v-card-actions class="d-flex justify-center mb-5 mt-2">
                  <v-btn large color="primary" @click="submitComment"> ToDo aktualisieren </v-btn>
                </v-card-actions>
              </div>
              <div v-if="currentTodo && currentTodo.comments && currentTodo.comments.filter((e) => e.comment.length > 0).length">
                <h3 class="headline">
                  Kommentare <v-chip>{{ currentTodo.comments.filter((e) => e.comment.length > 0).length }}</v-chip>
                </h3>
                <v-list dense>
                  <v-list-item v-for="(comment, index) in reverse(currentTodo.comments.filter((e) => e.comment.length > 0))" :key="index">
                    <v-list-item-content>
                      <div class="subtitle-2">
                        {{ formatDate(comment.createdAt) }}
                        {{ comment.user.vorname }}
                        {{ comment.user.nachname }} <v-chip v-if="comment.marketingOnly" color="primary" class="ml-1" small>Marketing</v-chip>
                      </div>
                      <div>
                        {{ comment.comment }} <v-btn @click="copyTextToClipboard(comment?.comment)" icon><v-icon>mdi-content-copy</v-icon></v-btn>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>

              <v-divider class="my-3"></v-divider>

              <div v-if="currentTodo">
                <h3 class="headline d-flex align-center justify-space-between">
                  Zugewiesene Benutzer
                  <v-btn v-if="userService.hasRight('todo_manageUsers')" icon class="primary" color="white" small @click="toggleAssignment">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </h3>
                <v-expand-transition>
                  <div class="mt-5" v-show="showAssignment">
                    <div class="justify-center d-flex flex-column">
                      <user-search
                        style="width: 100%"
                        class="mx-auto mb-2"
                        :value="newAssignedUser"
                        :key="assignedUserKey"
                        ignoreRights
                        :disabled="false"
                        instructor
                        label="Benutzer suchen"
                        @update="updateNewAssignedUser"></user-search>
                      <v-select
                        v-show="false"
                        v-model="newAssignmentRights"
                        :items="['read', 'comment', 'manage']"
                        label="Rechte"
                        outlined
                        dense></v-select>
                      <v-btn color="primary" class="mx-auto" @click="submitAssignment" :disabled="!newAssignedUser || !newAssignmentRights">
                        Zuweisen
                      </v-btn>
                    </div>
                  </div>
                </v-expand-transition>
                <v-list dense>
                  <v-list-item v-for="(user, index) in currentTodo.assignedUsers || []" :key="index">
                    <v-list-item-content> {{ user.user.vorname }} {{ user.user.nachname }} </v-list-item-content>
                    <v-list-item-actions v-if="userService.hasRight('todo_manageUsers')"
                      ><v-btn @click="removeUser(user._id)" icon><v-icon>mdi-account-minus</v-icon></v-btn></v-list-item-actions
                    >
                  </v-list-item>
                  <v-list-item v-if="!currentTodo.assignedUsers || currentTodo.assignedUsers.length === 0">
                    <v-list-item-content> Keine Benutzer zugewiesen. </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>

              <v-divider class="my-3"></v-divider>
            </div>
          </v-card-text>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog overlay-opacity="0.9" v-model="todoDialog" max-width="600px">
      <v-card dark>
        <v-card-title class="primary white--text">
          <span class="headline">{{ todoDialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="todoForm" v-model="formValid">
            <user-search
              style="width: 100%"
              class="mx-auto mt-5"
              :value="createdByUser"
              :key="assignedUserKey"
              ignoreRights
              :disabled="false"
              instructor
              label="Wer hat das ToDo erstellt?"
              @update="updateCreatedByUser"></user-search>
            <v-select v-model="editedTodo.category" :items="availableCategories" label="Kategorie" hide-details></v-select>
            <v-select
              v-if="editedTodo.category === 'marketing'"
              v-model="editedTodo.subcategory"
              :items="[
                { text: 'Umbau', value: 'Umbau' },
                { text: 'Events', value: 'Events' },
                { text: 'News', value: 'News' },
                { text: 'Sonstiges', value: 'Sonstiges' },
              ]"
              label="Unterkategorie"
              hide-details></v-select>
            <v-select
              v-if="editedTodo.category === 'coo' && userService.hasRight('coo_toDoListItems')"
              v-model="editedTodo.subcategory"
              :items="sortedCooSubcategories"
              label="Unterkategorie"
              hide-details></v-select>
            <v-select
              v-if="editedTodo.category === 'cl' && userService.hasRight('cl_toDoListItems')"
              v-model="editedTodo.subcategory"
              :items="sortedClSubcategories"
              label="Unterkategorie"
              hide-details></v-select>
            <v-text-field v-model="editedTodo.title" label="Titel" :rules="[(v) => !!v || 'Pflichtfeld']"></v-text-field>
            <v-textarea v-model="editedTodo.description" label="Beschreibung"></v-textarea>

            <v-select
              v-if="editedTodo.category !== 'marketing' || userService.hasRight('todo_fetchAllMarketing')"
              v-model="editedTodo.priority"
              :items="priorityItems"
              label="Priorität"
              :rules="[(v) => !!v || 'Pflichtfeld']">
              <template v-slot:selection="{ item }">
                <v-chip :color="getPriorityColor(item)" dark>{{ mapPriorityName(item) }}</v-chip>
              </template>
              <template v-slot:item="{ item }">
                <v-chip :color="getPriorityColor(item)" dark>{{ mapPriorityName(item) }}</v-chip>
              </template>
            </v-select>
            <v-select
              v-if="userService.hasRight('todo_changeStudio')"
              :items="studios"
              label="Studio auswählen"
              v-model="editedTodo.studio"
              item-text="name"
              item-value="_id"></v-select>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="blue darken-1" @click="closeTodoDialog">Abbrechen</v-btn>
          <v-btn text color="blue darken-1" @click="saveTodo" :disabled="!formValid">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
  <v-container v-else fluid>
    <v-alert type="info">Dieser Bereich ist nicht freigeschaltet</v-alert>
  </v-container>
</template>

<script>
import api from "@/api"
import userSearch from "@/components/userSearch.vue"
import { mapState, mapActions, mapGetters } from "vuex"
import userService from "@/services/userService"
import { saveAs } from "file-saver"
import socketService from "@/socketService" // NEU importieren
export default {
  name: "toDoListMain",
  components: { userSearch },
  data() {
    return {
      userService,
      // HIERMIT ERSETZEN
      selectedFile: null,
      videoLinkDialog: false,
      onlyUserTodos: false,
      activeTab: "techniker", // 0 = offene Todos, 1 = erledigte Todos
      technikerSearchActive: false,
      technikerSearchQuery: "",
      marketingSearchActive: false,
      marketingSearchQuery: "",
      cooSearchActive: false,
      cooSearchQuery: "",
      // NEW: CL Search state
      clSearchActive: false,
      clSearchQuery: "",
      // END NEW
      openTodos: [],
      resolvedTodos: [],
      priorityItems: ["low", "medium", "high"],
      todoDialog: false,
      todoDialogTitle: "",
      // editedTodo wird sowohl für Create als auch für Edit genutzt
      editedTodo: {
        _id: null,
        title: "",
        description: "",
        priority: "medium",
        studio: null,
        plannedDate: null,
        plannedTime: null,
        category: "techniker",
        subcategory: null,
      },
      imageDialog: null,
      attachementDialog: null,
      selectedImageIndex: null,
      selectedAttachementIndex: null,
      dateMenu: false,
      timeMenu: false,
      formValid: false,
      // Detail Dialog bezogene Daten
      detailDialog: false,
      currentTodo: null, // Todo für Detailanzeige
      currentTodoImages: [],
      currentTodoAttachments: [],
      newVideoLink: "",
      editMode: false,
      // Kommentar und Status
      newComment: "",
      isResolved: false,
      isMarketingOnlyComment: false,
      // Zuweisungsbezogene Daten
      newAssignedUser: null,
      newAssignmentRights: "manage",
      showAssignment: false,
      selectedStudio: null,
      openSearchActive: false,
      openSearchQuery: "",
      resolvedSearchActive: false,
      resolvedSearchQuery: "",
      assignedUserKey: 0,
      createdByUser: null,
      studios: [],
    }
  },
  beforeDestroy() {
    // It's crucial to clean up listeners to prevent memory leaks
    socketService.off("todo_updated")
  },
  async created() {
    this.setupSocketListeners()
    let studios = await api.fetchStudios()
    this.studios = studios
      .filter((studio) => studio.code && studio.code !== "ot" && studio.code !== "alibey")
      .map((studio) => {
        return { _id: studio._id, name: studio.name }
      })
    this.selectedStudio = this.userStudio
    this.fetchOpenTodos()
  },
  watch: {
    async currentTodo(newVal) {
      this.currentTodoAttachments.forEach((att) => {
        if (att.objectUrl) {
          URL.revokeObjectURL(att.objectUrl)
        }
      })
      this.currentTodoAttachments = []
      if (newVal && newVal.attachments) {
        for (let attachment of newVal.attachments) {
          try {
            if (attachment.type === "video") {
              // Video-Links direkt verwenden
              this.currentTodoAttachments.push({ ...attachment, url: attachment.filePath })
            } else if (attachment.type === "image") {
              // Bilder als Base64 für die direkte Anzeige laden
              let base64Url = await api.toDoList.fetchAttachment(attachment.filePath, true)
              this.currentTodoAttachments.push({ ...attachment, url: base64Url })
            } else {
              // Andere Dateien (PDF, DOC) als Blob laden und eine Object-URL erstellen
              const blob = await api.toDoList.fetchAttachment(attachment.filePath, false)
              const objectUrl = URL.createObjectURL(blob)
              this.currentTodoAttachments.push({ ...attachment, url: objectUrl, objectUrl: objectUrl })
            }
          } catch (error) {
            console.error("Fehler beim Laden des Anhangs:", error)
          }
        }
      }
      this.currentTodoImages = []
      if (newVal.images) {
        for (let image of newVal.images) {
          try {
            let downloadedImage = await api.toDoList.fetchImage(image.filePath)
            this.currentTodoImages.push(downloadedImage)
          } catch (e) {
            console.log(error)
          }
        }
      }
    },
    // Beim Wechseln des Tabs werden jeweils die entsprechenden Todos geladen
    activeTab(newVal) {
      if (newVal === "resolved") {
        this.fetchResolvedTodos()
      } else {
        this.fetchOpenTodos()
      }
    },
  },
  computed: {
    ...mapState("studioStore", ["storeStudios"]),
    availableCategories() {
      let categories = [
        { text: "Techniker", value: "techniker" },
        { text: "Marketing", value: "marketing" },
      ]
      if (this.userService.hasRight("coo_toDoListItems")) {
        categories.push({ text: "Coo", value: "coo" })
      }
      // NEW: Add CL category if user has right
      if (this.userService.hasRight("cl_toDoListItems")) {
        categories.push({ text: "CL", value: "cl" })
      }
      // END NEW
      return categories
    },
    sortedCooSubcategories() {
      const subcategories = [
        { text: "Solarium", value: "Solarium" },
        { text: "Me-Scan", value: "Me-Scan" },
        { text: "Hydrojet", value: "Hydrojet" },
        { text: "Ausdauergeräte", value: "Ausdauergeräte" },
        { text: "Kraftgeräte", value: "Kraftgeräte" },
        { text: "Senso Pro", value: "Senso Pro" },
        { text: "Milon", value: "Milon" },
        { text: "Stretching", value: "Stretching" },
        { text: "Plate Loaded", value: "Plate Loaded" },
        { text: "Kabeltürme", value: "Kabeltürme" },
        { text: "Workout ", value: "Workout " },
        { text: "LH", value: "LH" },
        { text: "KH", value: "KH" },
        { text: "Racks", value: "Racks" },
        { text: "MP", value: "MP" },
        { text: "Functional", value: "Functional" },
        { text: "Group Fitness", value: "Group Fitness" },
        { text: "Wellness", value: "Wellness" },
        { text: "Getränkeanlage", value: "Getränkeanlage" },
        { text: "Power Plate", value: "Power Plate" },
        { text: "Kinderhort", value: "Kinderhort" },
        { text: "Pelvix Power", value: "Pelvix Power" },
        { text: "Shop", value: "Shop" },
        { text: "Abfall", value: "Abfall" },
        { text: "Allgemein", value: "Allgemein" },
        { text: "roody", value: "roody" },
        { text: "TAC", value: "TAC" },
        { text: "Schulungen", value: "Schulungen" },
      ]
      // Sortiere das Array alphabetisch basierend auf dem 'text'-Feld
      return subcategories.sort((a, b) => a.text.localeCompare(b.text))
    },
    // NEW: Sorted CL Subcategories (You might define specific ones or reuse existing)
    sortedClSubcategories() {
      const subcategories = [
        { text: "Solarium", value: "Solarium" },
        { text: "Me-Scan", value: "Me-Scan" },
        { text: "Hydrojet", value: "Hydrojet" },
        { text: "Ausdauergeräte", value: "Ausdauergeräte" },
        { text: "Kraftgeräte", value: "Kraftgeräte" },
        { text: "Senso Pro", value: "Senso Pro" },
        { text: "Milon", value: "Milon" },
        { text: "Stretching", value: "Stretching" },
        { text: "Plate Loaded", value: "Plate Loaded" },
        { text: "Kabeltürme", value: "Kabeltürme" },
        { text: "Workout ", value: "Workout " },
        { text: "LH", value: "LH" },
        { text: "KH", value: "KH" },
        { text: "Racks", value: "Racks" },
        { text: "MP", value: "MP" },
        { text: "Functional", value: "Functional" },
        { text: "Group Fitness", value: "Group Fitness" },
        { text: "Wellness", value: "Wellness" },
        { text: "Getränkeanlage", value: "Getränkeanlage" },
        { text: "Power Plate", value: "Power Plate" },
        { text: "Kinderhort", value: "Kinderhort" },
        { text: "Pelvix Power", value: "Pelvix Power" },
        { text: "Shop", value: "Shop" },
        { text: "Abfall", value: "Abfall" },
        { text: "Allgemein", value: "Allgemein" },
        { text: "roody", value: "roody" },
        { text: "TAC", value: "TAC" },
        { text: "Schulungen", value: "Schulungen" },
      ]
      // Sortiere das Array alphabetisch basierend auf dem 'text'-Feld
      return subcategories.sort((a, b) => a.text.localeCompare(b.text))
    },
    // END NEW
    headers() {
      let headers = [
        { text: "Titel", value: "title" },
        { text: "Ersteller", value: "createdBy" },
        { text: "Zugewiesen", value: "assignedUsers" },
        { text: "Studio", value: "studio" },
        { text: "Priorität", value: "priority" },
        { text: "Geplant", value: "plannedDate" },
      ]
      console.log("CALCULATING HEADERS", this.activeTab)
      // NEW: Adjust headers for CL
      if (
        this.activeTab === "marketing" ||
        (this.activeTab === "coo" && this.userService.hasRight("coo_toDoListItems")) ||
        (this.activeTab === "cl" && this.userService.hasRight("cl_toDoListItems"))
      )
        headers.push({ text: "Kat.", value: "subcategory" })
      headers.push({ text: "Erstellt am", value: "createdAt" })
      return headers
    },
    headersMarketing() {
      let headers = [
        { text: "Titel", value: "title" },
        { text: "Ersteller", value: "createdBy" },
        { text: "Zugewiesen", value: "assignedUsers" },
        { text: "Studio", value: "studio" },
        { text: "Priorität", value: "priority" },
      ]
      if (this.userService.hasRight("todo_fetchAllMarketing")) {
        headers.push({ text: "In Bearb.", value: "inProgress" })
      }
      if (this.activeTab === "marketing") headers.push({ text: "Kat.", value: "subcategory" })
      headers.push({ text: "Erstellt am", value: "createdAt" })
      return headers
    },
    technikerTodos() {
      return this.openTodos.filter((todo) => todo.category === "techniker")
    },
    marketingTodos() {
      return this.openTodos.filter((todo) => todo.category === "marketing")
    },
    cooTodos() {
      if (this.userService.hasRight("coo_toDoListItems")) {
        return this.openTodos.filter((todo) => todo.category === "coo")
      }
      return [] // If no rights, return an empty array
    },
    // NEW: CL Todos computed property
    clTodos() {
      if (this.userService.hasRight("cl_toDoListItems")) {
        return this.openTodos.filter((todo) => todo.category === "cl")
      }
      return []
    },
    // END NEW
    filteredOpenTodos() {
      let todosToFilter = this.openTodos
      if (!this.userService.hasRight("coo_toDoListItems")) {
        todosToFilter = todosToFilter.filter((todo) => todo.category !== "coo")
      }
      // NEW: Exclude CL todos if user doesn't have rights
      if (!this.userService.hasRight("cl_toDoListItems")) {
        todosToFilter = todosToFilter.filter((todo) => todo.category !== "cl")
      }
      // END NEW

      if (!this.openSearchQuery) return todosToFilter
      const query = this.openSearchQuery.toLowerCase()
      return todosToFilter.filter((todo) => this.matchesTodo(todo, query))
    },
    filteredResolvedTodos() {
      // MODIFIED: Ensure 'coo' and 'cl' todos are only included in search if the user has rights
      let todosToFilter = this.resolvedTodos
      if (!this.userService.hasRight("coo_toDoListItems")) {
        todosToFilter = todosToFilter.filter((todo) => todo.category !== "coo")
      }
      // NEW: Exclude CL todos if user doesn't have rights
      if (!this.userService.hasRight("cl_toDoListItems")) {
        todosToFilter = todosToFilter.filter((todo) => todo.category !== "cl")
      }
      // END NEW

      if (!this.resolvedSearchQuery) return todosToFilter
      const query = this.resolvedSearchQuery.toLowerCase()
      return todosToFilter.filter((todo) => this.matchesTodo(todo, query))
    },
    // Gruppierung der erledigten Todos anhand der gefilterten Liste
    groupedResolvedTodosFiltered() {
      const groups = {}
      this.filteredResolvedTodos.forEach((todo) => {
        const date = new Date(todo.createdAt)
        const year = date.getFullYear()
        const month = date.getMonth() // 0-basiert
        if (!groups[year]) {
          groups[year] = {}
        }
        if (!groups[year][month]) {
          groups[year][month] = {
            techniker: [],
            marketing: [],
            coo: [],
            cl: [], // NEW: Add cl array for resolved todos
          }
        }
        // To-do der korrekten Kategorie zuweisen
        if (todo.category === "techniker") {
          groups[year][month].techniker.push(todo)
        } else if (todo.category === "marketing") {
          groups[year][month].marketing.push(todo)
        } else if (todo.category === "coo") {
          groups[year][month].coo.push(todo)
        } else if (todo.category === "cl") {
          // NEW: Handle CL category
          groups[year][month].cl.push(todo)
        }
      })
      // Transformiere die gruppierten Daten in ein sortiertes Array für die Anzeige
      return Object.keys(groups)
        .sort((a, b) => b - a) // Jahre absteigend sortieren
        .map((year) => {
          const months = Object.keys(groups[year])
            .sort((a, b) => b - a) // Monate absteigend sortieren
            .map((month) => {
              const technikerTodos = groups[year][month].techniker.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
              const marketingTodos = groups[year][month].marketing.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
              const cooTodos = groups[year][month].coo.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
              const clTodos = groups[year][month].cl.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) // NEW: Sort CL todos
              return {
                month,
                monthName: new Date(2020, month).toLocaleString("default", { month: "long" }),
                techniker: technikerTodos,
                marketing: marketingTodos,
                coo: cooTodos,
                cl: clTodos, // NEW: Include CL todos
                totalCount: technikerTodos.length + marketingTodos.length + cooTodos.length + clTodos.length, // NEW: Update totalCount
              }
            })
            .filter((month) => month.totalCount > 0) // Nur Monate mit To-dos anzeigen
          return { year, months }
        })
        .filter((year) => year.months.length > 0) // Nur Jahre mit To-dos anzeigen
    },
    userStudio() {
      return this.userService.getStudio()?._id || null
    },
    studiosOld() {
      // Standardmäßig werden nur offene Todos geladen
      return this.storeStudios
        .filter((studio) => studio.code && studio.code !== "ot" && studio.code !== "alibey")
        .map((studio) => {
          return { _id: studio._id, name: studio.name }
        })
    },
    groupedResolvedTodos() {
      const groups = {}
      this.resolvedTodos.forEach((todo) => {
        const date = new Date(todo.createdAt)
        const year = date.getFullYear()
        const month = date.getMonth() // 0-basiert
        if (!groups[year]) groups[year] = {}
        if (!groups[year][month]) groups[year][month] = []
        groups[year][month].push(todo)
      })
      // Transformiere die gruppierten Daten in ein Array, sortiert nach Jahr und Monat (absteigend)
      return Object.keys(groups)
        .sort((a, b) => b - a)
        .map((year) => {
          const months = Object.keys(groups[year])
            .sort((a, b) => b - a)
            .map((month) => ({
              month: month,
              monthName: new Date(2020, month).toLocaleString("default", { month: "long" }),
              todos: groups[year][month].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)),
            }))
          return { year, months }
        })
    },
  },
  methods: {
    setupSocketListeners() {
      // Make sure to remove any previous listener before adding a new one
      socketService.off("todo_updated")
      socketService.on("todo_updated", (updatedTodo) => {
        console.log("ToDo-Aktualisierung empfangen:", updatedTodo)
        this.$toast.info(`ToDo "${updatedTodo.title}" wurde aktualisiert!`)
        // --- Logic to intelligently update your local lists ---
        // 1. Remove the old version from both arrays, if it exists
        this.openTodos = this.openTodos.filter((todo) => todo._id !== updatedTodo._id)
        this.resolvedTodos = this.resolvedTodos.filter((todo) => todo._id !== updatedTodo._id)
        // 2. Add the updated To-Do to the correct array based on its status
        if (updatedTodo.resolved) {
          // Add to the beginning of the resolvedTodos array
          this.resolvedTodos.unshift(updatedTodo)
        } else {
          // Add priorityValue for sorting before pushing to openTodos
          let priorityValue = 0
          if (updatedTodo.priority === "high") priorityValue = 3
          else if (updatedTodo.priority === "medium") priorityValue = 2
          else if (updatedTodo.priority === "low") priorityValue = 1
          const todoWithPriority = { ...updatedTodo, priorityValue }
          // Add to the beginning of the openTodos array
          this.openTodos.unshift(todoWithPriority)
        }
        // 3. If the updated To-Do is the one currently open in the detail dialog, refresh it
        if (this.currentTodo && this.currentTodo._id === updatedTodo._id) {
          this.currentTodo = updatedTodo
        }
      })
    },
    copyTextToClipboard(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$toast.success("Text in die Zwischenablage kopiert")
        })
        .catch((error) => {
          console.error("Fehler beim Kopieren:", error)
          this.$toast.error("Fehler beim Kopieren des Textes.")
        })
    },
    // HINZUFÜGEN (innerhalb von methods: { ... })
    async openAttachment(attachment) {
      try {
        // 1. Lade die Datei als Blob vom Server
        const blob = await api.toDoList.fetchAttachment(attachment.filePath, false)
        // 2. Prüfe, ob die App in einer Flutter Webview läuft
        if (window.flutter_inappwebview) {
          console.log("Flutter InAppWebView erkannt. Verwende Handler...")
          const reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onloadend = function () {
            const dataUrl = reader.result
            // Extrahiere den reinen Base64-Teil
            const base64 = dataUrl.split(",")[1]
            // Extrahiere die Dateiendung
            const fileExtension = attachment.originalName.split(".").pop()
            window.flutter_inappwebview.callHandler("blobToBase64Handler", base64.toString(), fileExtension, attachment.originalName)
          }
        } else {
          // 3. Standard-Verhalten im Web-Browser: Datei speichern
          console.log("Standard-Browser erkannt. Starte Download...")
          saveAs(blob, attachment.originalName)
        }
      } catch (error) {
        console.error("Fehler beim Öffnen des Anhangs:", error)
        this.$toast.error("Anhang konnte nicht geöffnet werden.")
      }
    },
    triggerFileUpload() {
      // Triggert einen Klick auf das versteckte Input-Feld
      this.$refs.fileInput.$el.querySelector("input").click()
    },
    onFileSelected(file) {
      // Wird aufgerufen, sobald eine Datei ausgewählt wurde
      if (!file) return
      this.uploadAttachment(file, this.currentTodo)
      // Setzt die Auswahl zurück, damit die @change-Methode erneut auslöst
      this.selectedFile = null
    },
    filteredTodosByCategory(cat) {
      // MODIFIED: Add a check for COO and CL rights here as well
      if (cat === "coo" && !this.userService.hasRight("coo_toDoListItems")) {
        return []
      }
      // NEW: Check CL rights
      if (cat === "cl" && !this.userService.hasRight("cl_toDoListItems")) {
        return []
      }
      // END NEW

      let list = this.openTodos.filter((t) => t.category === cat)
      const query = (
        cat === "techniker"
          ? this.technikerSearchQuery
          : cat === "marketing"
          ? this.marketingSearchQuery
          : cat === "coo"
          ? this.cooSearchQuery
          : this.clSearchQuery
      ) // NEW: Add clSearchQuery
        .toLowerCase()
      if (!query) return list
      return list.filter((todo) => this.matchesTodo(todo, query))
    },
    deleteSelectedImage() {
      if (confirm("möchtest du das Bild wirklich löschen?")) {
        if (this.currentTodo && this.currentTodo.images && this.currentTodo.images[this.selectedImageIndex]) {
          const imageIndex = this.selectedImageIndex
          api.toDoList
            .deleteImage({ _id: this.currentTodo._id, imageIndex })
            .then(() => {
              this.$toast.success("Bild erfolgreich gelöscht")
              this.selectedImageIndex = null
              this.imageDialog = false
              this.reloadTodos()
            })
            .catch((error) => {
              console.error("Fehler beim Löschen des Bildes", error)
            })
        }
      }
    },
    openAttachementDialog(index) {
      this.selectedAttachementIndex = index
      this.attachementDialog = true
    },
    openImageDialog(index) {
      this.selectedImageIndex = index
      this.imageDialog = true
    },
    uploadImages(file, entry) {
      console.log("starting image upload")
      const reader = new FileReader()
      reader.onload = (e) => {
        const formData = new FormData()
        formData.append("file", file)
        api.toDoList
          .uploadImages(formData, entry._id)
          .then((response) => {
            this.$toast.success("Bild/er erfolgreich hochgeladen")
            this.reloadTodos()
          })
          .catch((error) => {
            console.log("Upload failed", error)
          })
      }
      reader.readAsDataURL(file)
    },
    // ERSETZEN MIT
    deleteSelectedAttachment(attachmentId) {
      if (confirm("Möchtest du diesen Anhang wirklich löschen?")) {
        api.toDoList
          .deleteAttachment({ _id: this.currentTodo._id, attachmentId })
          .then(() => {
            this.$toast.success("Anhang erfolgreich gelöscht")
            this.imageDialog = false // Schliesst Bild-Dialog, falls offen
            this.reloadTodos() // Lädt das Todo neu, um die Attachment-Liste zu aktualisieren
          })
          .catch((error) => {
            console.error("Fehler beim Löschen des Anhangs", error)
            this.$toast.error("Fehler beim Löschen des Anhangs.")
          })
      }
    },
    uploadAttachment(file, entry) {
      const formData = new FormData()
      formData.append("file", file)
      api.toDoList
        .uploadAttachment(formData, entry._id)
        .then(() => {
          this.$toast.success("Datei erfolgreich hochgeladen")
          this.reloadTodos()
        })
        .catch((error) => {
          this.$toast.error(error.response?.data?.message || "Upload fehlgeschlagen")
          console.log("Upload failed", error)
        })
    },
    // HINZUFÜGEN (innerhalb von methods: { ... })
    getAttachmentIcon(type) {
      if (type === "pdf") return "mdi-file-pdf-box"
      if (type === "video") return "mdi-youtube" // oder mdi-video
      return "mdi-file-document"
    },
    addVideoLink() {
      if (!this.newVideoLink || !this.newVideoLink.startsWith("http")) {
        this.$toast.error("Bitte geben Sie einen gültigen Video-Link ein.")
        return
      }
      api.toDoList
        .addVideoLink(this.currentTodo._id, { videoLink: this.newVideoLink })
        .then(() => {
          this.$toast.success("Video-Link erfolgreich hinzugefügt")
          this.newVideoLink = ""
          this.videoLinkDialog = false // Schließt den Dialog
          this.reloadTodos()
        })
        .catch((error) => {
          console.error("Fehler beim Hinzufügen des Video-Links", error)
          this.$toast.error("Fehler beim Hinzufügen des Links.")
        })
    },
    getPlannedDateOfEntry(item) {
      if (item.plannedDate && item.plannedTime) {
        return this.$moment(item.plannedDate).format("DD.MM.YY") + " " + item.plannedTime
      } else if (item.plannedDate) {
        return this.$moment(item.plannedDate).format("DD.MM.YY")
      } else if (item.plannedTime) {
        return item.plannedTime
      }
      return ""
    },
    matchesTodo(todo, query) {
      // Prüfe Titel und Beschreibung
      if (todo.title && todo.title.toLowerCase().includes(query)) return true
      if (todo.description && todo.description.toLowerCase().includes(query)) return true
      // Prüfe Studio (Name)
      if (todo.studio && todo.studio.name && todo.studio.name.toLowerCase().includes(query)) return true
      // Prüfe Ersteller (vorname und nachname)
      if (todo.createdBy) {
        if (todo.createdBy.vorname && todo.createdBy.vorname.toLowerCase().includes(query)) return true
        if (todo.createdBy.nachname && todo.createdBy.nachname.toLowerCase().includes(query)) return true
      }
      // Prüfe zugewiesene Benutzer
      if (todo.assignedUsers && Array.isArray(todo.assignedUsers)) {
        for (const assigned of todo.assignedUsers) {
          if (assigned.user) {
            if (assigned.user.vorname && assigned.user.vorname.toLowerCase().includes(query)) return true
            if (assigned.user.nachname && assigned.user.nachname.toLowerCase().includes(query)) return true
          }
        }
      }
      return false
    },
    mapPriorityName(priority) {
      if (priority === "high") return "Hoch"
      if (priority === "medium") return "Mittel"
      if (priority === "low") return "Niedrig"
      return "Unbekannt"
    },
    reverse(array) {
      return array.slice().reverse()
    },
    getPriorityColor(priority) {
      if (priority === "high") return "red"
      if (priority === "medium") return "orange"
      if (priority === "low") return "green"
      return "grey"
    },
    formatDate(date) {
      return date ? this.$moment(date).format("DD.MM.YY HH:mm") : ""
    },
    fetchOpenTodos() {
      api.toDoList
        .fetchAll({ status: "open", studio: this.selectedStudio, onlyUserTodos: this.onlyUserTodos })
        .then((data) => {
          this.openTodos = data.map((todo) => {
            let priorityValue = 0
            if (todo.priority === "high") priorityValue = 3
            else if (todo.priority === "medium") priorityValue = 2
            else if (todo.priority === "low") priorityValue = 1
            return { ...todo, priorityValue }
          })
          if (this.currentTodo && this.currentTodo._id) {
            // Wenn ein Todo geöffnet ist, wird es neu geladen
            this.currentTodo = this.openTodos.find((todo) => todo._id === this.currentTodo._id)
          }
        })
        .catch((err) => {
          console.error("Fehler beim Laden offener Todos", err)
        })
    },
    fetchResolvedTodos() {
      api.toDoList
        .fetchAll({ status: "resolved", studio: this.selectedStudio, onlyUserTodos: this.onlyUserTodos })
        .then((data) => {
          this.resolvedTodos = data.map((todo) => {
            let priorityValue = 0
            if (todo.priority === "high") priorityValue = 3
            else if (todo.priority === "medium") priorityValue = 2
            else if (todo.priority === "low") priorityValue = 1
            return { ...todo, priorityValue }
          })
          if (this.currentTodo && this.currentTodo._id) {
            // Wenn ein Todo geöffnet ist, wird es neu geladen
            this.currentTodo = this.resolvedTodos.find((todo) => todo._id === this.currentTodo._id)
          }
        })
        .catch((err) => {
          console.error("Fehler beim Laden erledigter Todos", err)
        })
    },
    reloadTodos() {
      if (this.activeTab === "techniker" || this.activeTab === "marketing" || this.activeTab === "coo" || this.activeTab === "cl") {
        // NEW: Add cl to condition
        this.fetchOpenTodos()
      } else {
        this.fetchResolvedTodos()
      }
    },
    openCreateDialog() {
      this.todoDialogTitle = "Neuer ToDo Eintrag"
      this.createdByUser = null
      this.assignedUserKey += 1
      this.editedTodo = {
        _id: null,
        title: "",
        studio: this.userStudio,
        createdBy: null,
        description: "",
        priority: "low",
        category: "techniker",
        subcategory: null,
        plannedDate: null,
        plannedTime: null,
      }
      this.todoDialog = true
    },
    closeTodoDialog() {
      this.todoDialog = false
    },
    saveTodo() {
      if (this.editedTodo.title.trim() === "") {
        this.$toast.error("Der Titel ist ein Pflichtfeld")
        return
      }
      if (this.editedTodo.description.trim() === "") {
        this.$toast.error("Die Beschreibung ist ein Pflichtfeld")
        return
      }
      if (this.editedTodo.description.length < 30) {
        this.$toast.error("Die Beschreibung muss mindestens 30 Zeichen lang sein")
        return
      }
      // NEW: Add similar priority override for CL if needed
      if (
        (this.editedTodo.category === "marketing" && !userService.hasRight("todo_fetchAllMarketing") && this.editedTodo.priority !== "low") ||
        (this.editedTodo.category === "cl" && !userService.hasRight("cl_toDoListItems") && this.editedTodo.priority !== "low")
      ) {
        this.editedTodo.priority = "low"
        this.$toast.info("Priorität wird vom Marketing-Team oder CL-Team gesetzt")
      }
      // END NEW
      if (this.editedTodo._id) {
        // Update
        api.toDoList
          .update(this.editedTodo._id, this.editedTodo)
          .then(() => {
            if (this.editedTodo.studio !== this.selectedStudio) {
              this.selectedStudio = this.editedTodo.studio
              let studioName = this.studios.find((s) => s._id === this.selectedStudio)?.name || "Fehler "
              this.$toast.info("Das Studio wurde auf " + studioName + " gesetzt")
            }
            if (this.activeTab !== this.editedTodo.category) {
              this.activeTab = this.editedTodo.category
            } else {
              this.reloadTodos()
            }
            this.todoDialog = false
          })
          .catch((err) => {
            console.error("Fehler beim Aktualisieren", err)
          })
      } else {
        // Neuer Eintrag
        if (!this.createdByUser) {
          this.$toast.error("Bitte einen Benutzer auswählen")
          return
        }
        this.editedTodo.createdBy = this.createdByUser
        api.toDoList
          .create(this.editedTodo)
          .then((e) => {
            if (this.editedTodo.studio !== this.selectedStudio) {
              this.selectedStudio = this.editedTodo.studio
              let studioName = this.studios.find((s) => s._id === this.selectedStudio)?.name || "Fehler "
              this.$toast.info("Das Studio wurde auf " + studioName + " gesetzt")
            }
            console.log(this.activeTab, "AKTIVER TAB")
            if (this.activeTab !== this.editedTodo.category) {
              console.log("Wechsel zu Kategorie", this.editedTodo.category)
              this.activeTab = this.editedTodo.category
            } else {
              this.reloadTodos()
            }
            this.openDetailDialog(e)
            this.todoDialog = false
          })
          .catch((err) => {
            console.error("Fehler beim Erstellen", err)
          })
      }
    },
    // Detail Dialog öffnen und initialisieren
    openDetailDialog(item) {
      this.currentTodo = {
        plannedDate: item.plannedDate || null,
        plannedTime: item.plannedTime || null,
        inProgress: item.inProgress || false,
        ...item,
      }
      this.editMode = false
      this.newComment = ""
      this.isMarketingOnlyComment = false
      this.showAssignment = false
      // Checkbox automatisch setzen, falls Todo resolved ist
      this.isResolved = item.resolved
      this.detailDialog = true
    },
    closeDetailDialog() {
      this.detailDialog = false
    },
    toggleEditMode() {
      this.editMode = !this.editMode
      if (this.editMode && this.currentTodo) {
        // Vor dem Bearbeiten die aktuellen Werte kopieren
        this.editedTodo = {
          _id: this.currentTodo._id,
          title: this.currentTodo.title,
          description: this.currentTodo.description,
          studio: this.currentTodo.studio?._id || this.currentTodo.studio || null,
          priority: this.currentTodo.priority,
          category: this.currentTodo.category,
          subcategory: this.currentTodo.subcategory || null,
          plannedDate: this.currentTodo.plannedDate || null,
          plannedTime: this.currentTodo.plannedTime || null,
        }
      }
    },
    saveEdit() {
      if (this.editedTodo.title.trim() === "") {
        this.$toast.error("Der Titel ist ein Pflichtfeld")
        return
      }
      if (this.editedTodo.description.trim() === "") {
        this.$toast.error("Die Beschreibung ist ein Pflichtfeld")
        return
      }
      if (this.editedTodo.description.length < 30) {
        this.$toast.error("Die Beschreibung muss mindestens 30 Zeichen lang sein")
        return
      }
      const payload = {
        title: this.editedTodo.title,
        description: this.editedTodo.description,
        priority: this.editedTodo.priority,
        studio: this.editedTodo.studio?._id || this.editedTodo.studio || null,
        category: this.editedTodo.category || "techniker",
        subcategory: this.editedTodo.subcategory || null,
      }
      api.toDoList
        .update(this.currentTodo._id, payload)
        .then(() => {
          if (this.currentTodo.studio._id !== payload.studio) {
            this.selectedStudio = payload.studio
            let studioName = this.studios.find((s) => s._id === payload.studio)?.name || "Fehler "
            this.$toast.info("Das Studio wurde auf " + studioName + " gesetzt")
          }
          this.activeTab = this.isResolved ? "resolved" : this.currentTodo.category
          this.editMode = false
          this.reloadTodos()
        })
        .catch((err) => {
          console.error("Fehler beim Aktualisieren", err)
        })
    },
    deleteCurrentTodo() {
      if (confirm("Möchtest du diesen Eintrag wirklich löschen?")) {
        api.toDoList
          .delete(this.currentTodo._id)
          .then(() => {
            this.closeDetailDialog()
            this.reloadTodos()
          })
          .catch((err) => {
            console.error("Fehler beim Loeschen", err)
          })
      }
    },
    updateInProgressStatus() {
      const payload = {
        inProgress: this.currentTodo.inProgress,
      }
      api.toDoList
        .update(this.currentTodo._id, payload)
        .then(() => {
          this.$toast.success("Status aktualisiert")
          // Lade die Liste neu, um die Änderung in der Tabelle zu sehen
          this.fetchOpenTodos()
        })
        .catch((err) => {
          this.$toast.error("Fehler beim Aktualisieren des Status.")
          console.error("Fehler beim Aktualisieren des inProgress-Status", err)
          // Setze den Schalter zurück, wenn ein Fehler auftritt
          this.currentTodo.inProgress = !this.currentTodo.inProgress
        })
    },
    submitComment() {
      if (!(this.currentTodo && this.currentTodo.resolved && !this.isResolved) || confirm("Möchtest du das Todo wieder öffnen?")) {
        const payload = {
          comment: this.newComment,
          plannedDate: this.currentTodo.plannedDate || null,
          plannedTime: this.currentTodo.plannedTime || null,
          status: this.isResolved ? "resolved" : "opened",
          marketingOnly: this.isMarketingOnlyComment,
        }
        api.toDoList
          .addComment(this.currentTodo._id, payload)
          .then(() => {
            this.newComment = ""
            this.isMarketingOnlyComment = false
            // Check if the To-Do's new status requires a tab switch
            const newTab = this.isResolved ? "resolved" : this.currentTodo.category
            if (this.activeTab === newTab) {
              // If we are already on the correct tab, just reload the data
              this.reloadTodos()
            } else {
              // Otherwise, switch to the new tab
              this.activeTab = newTab
            }
            this.$toast.success("ToDo erfolgreich aktualisiert")
          })
          .catch((err) => {
            console.error("Fehler beim Hinzufuegen des Kommentars", err)
          })
      }
    },
    updateNewAssignedUser(newUser) {
      this.newAssignedUser = newUser
    },
    updateCreatedByUser(newUser) {
      this.createdByUser = newUser
    },
    removeUser(userId) {
      api.toDoList
        .removeAssignment(this.currentTodo._id, userId)
        .then(() => {
          this.currentTodo.assignedUsers = this.currentTodo.assignedUsers.filter((user) => user._id !== userId)
          this.reloadTodos()
        })
        .catch((err) => {
          console.error("Fehler beim Entfernen des Benutzers", err)
        })
    },
    submitAssignment() {
      const payload = {
        assignment: { user: this.newAssignedUser, rights: this.newAssignmentRights },
      }
      api.toDoList
        .assign(this.currentTodo._id, payload)
        .then(() => {
          if (this.currentTodo) {
            if (!this.currentTodo.assignedUsers) {
              this.$set(this.currentTodo, "assignedUsers", [])
            }
            this.currentTodo.assignedUsers.push({
              user: this.newAssignedUser.username,
              rights: this.newAssignmentRights,
            })
          }
          this.newAssignedUser = null
          this.assignedUserKey += 1
          this.newAssignmentRights = "manage"
          this.showAssignment = false
          this.reloadTodos()
        })
        .catch((err) => {
          console.error("Fehler beim Zuweisen des Benutzers", err)
        })
    },
    toggleAssignment() {
      this.showAssignment = !this.showAssignment
    },
  },
}
</script>

<style scoped>
/* Eigene Styles koennen hier hinzugefuegt werden */
</style>
